module.exports = __webpack_public_path__ + "img/oops.d29195e5.svg";